// src/utils/imageUtils.js
const IMAGE_SIGNATURES = [
  { prefix: '/9j/', mimeType: 'image/jpeg' },
  { prefix: 'iVBOR', mimeType: 'image/png' },
  { prefix: 'UklGR', mimeType: 'image/webp' },
];

export const getBase64ImageMimeType = (base64, fallbackMimeType = 'image/jpeg') => {
  const normalizedBase64 = String(base64 || '').trim();
  return IMAGE_SIGNATURES.find(({ prefix }) => normalizedBase64.startsWith(prefix))?.mimeType
    || fallbackMimeType;
};

export const createBase64ImageSource = (base64, mimeType) => {
  const normalizedBase64 = String(base64 || '').trim();
  if (!normalizedBase64) return '';

  const resolvedMimeType = mimeType || getBase64ImageMimeType(normalizedBase64);
  return `data:${resolvedMimeType};base64,${normalizedBase64}`;
};
